import { createContext, useContext } from 'react';
import noop, { NoOp } from 'utils/noop';
import { SHORTLINKS_MIN_VALUE } from 'modules/projectSettings/constants';

import { DEFAULT_LINK_SHORTENING_TRACKING_DOMAIN } from '../../EditSMS/constants';

export interface WhatsAppLinkShorteningContextState {
  isWhatsAppLinkShorteningEnabled: boolean;
  localStorageDomain: string;
  resetIsWhatsAppLinkShorteningEnabled: NoOp;
  setIsWhatsAppLinkShorteningEnabled: NoOp;
  setLocalStorageDomain: (newDomains: string[]) => void;
  shortlinkLength: number;
  defaultWhatsAppLinkShorteningDomain: string;
}

export const WhatsAppLinkShorteningContext = createContext<WhatsAppLinkShorteningContextState>({
  isWhatsAppLinkShorteningEnabled: false,
  localStorageDomain: '',
  resetIsWhatsAppLinkShorteningEnabled: noop,
  setIsWhatsAppLinkShorteningEnabled: noop,
  setLocalStorageDomain: noop,
  shortlinkLength: SHORTLINKS_MIN_VALUE,
  defaultWhatsAppLinkShorteningDomain: DEFAULT_LINK_SHORTENING_TRACKING_DOMAIN,
});

export const useWhatsAppLinkShortening = () => useContext(WhatsAppLinkShorteningContext);
